import { render } from "./Integralwallet.vue?vue&type=template&id=09662172&scoped=true&ts=true"
import script from "./Integralwallet.vue?vue&type=script&setup=true&lang=ts"
export * from "./Integralwallet.vue?vue&type=script&setup=true&lang=ts"

import "./Integralwallet.vue?vue&type=style&index=0&id=09662172&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09662172"],['__file',"src/views/me/Integralwallet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09662172"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09662172', __exports__)) {
    console.log('reload')
    api.reload('09662172', __exports__)
  }
  
  module.hot.accept("./Integralwallet.vue?vue&type=template&id=09662172&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('09662172', render)
  })

}


export default __exports__